import { Card, Stack, Text } from "@mantine/core";
import useTransientStore from "../../data/transcientStore";
import { useTranslation } from "../../hooks/useTranslation";
import { ReportSectionHeader } from "../reports/ReportSectionHeader";

interface SettingsPlaceholderViewProps {
  onBack: () => void;
  titleTranslationKey: string;
  defaultTitle: string;
}

/**
 * Placeholder until each legacy settings screen is migrated (PHP → RIMS).
 */
export default function SettingsPlaceholderView({
  onBack,
  titleTranslationKey,
  defaultTitle,
}: Readonly<SettingsPlaceholderViewProps>) {
  const selectedAddressSystemId =
    useTransientStore((s) => s.selectedAddressSystem?.id) ?? 0;
  const { getTranslation } = useTranslation({
    pageId: 512,
    addressSystemId: selectedAddressSystemId,
    autoLoad: true,
  });

  const title =
    getTranslation(titleTranslationKey) || defaultTitle;
  const contextLabel =
    getTranslation("SETTINGS_HUB_LABEL") || "Settings";
  const backLabel =
    getTranslation("SETTINGS_RETURN") || "Back to settings";
  const body =
    getTranslation("SETTINGS_PLACEHOLDER_BODY") ||
    "This section is not available in RIMS yet.";

  return (
    <Card withBorder radius="lg" px="xl" py="lg" shadow="sm">
      <Stack gap="md">
        <ReportSectionHeader
          onBack={onBack}
          contextLabel={contextLabel}
          title={title}
          backLabel={backLabel}
        />
        <Text c="dimmed" size="sm">
          {body}
        </Text>
      </Stack>
    </Card>
  );
}
